import { Modal } from "react-bootstrap";
import ModalHead from "../../../common/ui/ModalHead.js";
import ProductDetailsModalPage from "./product-details-parent/ProductDetailsModalPage.js";
import ProductComboListModalPage from "./product-combo-list/ProductComboListModalPage.js";
import ProductComboChildModalPage from "./product-combo-child/ProductComboChildModalPage.js";
import ModifierComboGroupsListModalPage from "./modifier-combo-groups-list/ModifierComboGroupsListModalPage.js";
import ModifierComboGroupDetailsModalPage from "./modifier-combo-group-details/ModifierComboGroupDetailsModalPage.js";

/* =============================================================================
   Product builder.
   -----------------------------------------------------------------------------
   One modal, five pages, chosen by productModalDisplay.showModalPage. The
   nesting goes four deep for brands that sell combos of combos:

     Parent Details
       → Product Combo List          (pick which product fills a combo slot)
         → Product Combo Child       (configure that product's own modifiers)
       → Modifier Combo Groups List  (a modifier that is itself a combo)
         → Modifier Combo Group Details

   ⚠ Only the chrome is redesigned here. The branch conditions, the formData
   lookups by fieldName and every handler are untouched — the fieldName strings
   (`ModComboModCatId${id}`) are the contract between this tree and App.js.

   ⚠ backdrop="static" / keyboard={false} stay. A half-built combo dismissed by
   a stray backdrop click loses the customer's whole selection.

   ⚠ The disabled={...ButtonsDisabled} flags on back and close are not cosmetic:
   they stop a second submission while an add-to-cart request is in flight.
   ============================================================================= */

const Head = ModalHead;

export default function ProductModal(props) {

    // Product Parent, Product Child or List
    let modalBody;
    if (props.productModalDisplay.showModalPage === "Parent Details") { // Regular Product Details
        modalBody =
            <>
                <Head
                    title={props.productModalDisplay.productType === "Regular" ? "Product Details" : "Product Combo Details"}
                    onClose={props.handleProductModalClose}
                    closeDisabled={props.addToCartError.ButtonsDisabled}
                />
                <ProductDetailsModalPage
                    // General
                    productModalDisplay={props.productModalDisplay}
                    currentLocation={props.currentLocation}
                    handleProductFormSubtractQuantity={props.handleProductFormSubtractQuantity}
                    handleProductFormAddQuantity={props.handleProductFormAddQuantity}
                    handleAddProductToCart={props.handleAddProductToCart}
                    addToCartError={props.addToCartError}
                    // Product
                    productDetails={props.productDetails}
                    productFormData={props.productFormData}
                    handleProductFormChange={props.handleProductFormChange}
                    handleModFormChange={props.handleModFormChange}
                    // Product Combo
                    handleProductComboGroupSelect={props.handleProductComboGroupSelect}
                    // Modifier Combo
                    handleModifierComboSelect={props.handleModifierComboSelect}
                    handleBackModifierComboSelect={props.handleBackModifierComboSelect}
                    handleRemoveModifierComboFromProduct={props.handleRemoveModifierComboFromProduct}
                />
            </>
    } else if (props.productModalDisplay.showModalPage === "Modifier Combo Groups List") { // Regular Product - Modifier Groups List inside selected Modifier Combo
        let modifierComboGroupFormData =  props.productFormData.data.Mods.find((item) => {
            return item.fieldName == `ModComboModCatId${props.modifierComboDetails.modifierComboDetails.modCategoryId}`
        });

        modalBody =
        <>
            <Head
                title="Add Combo to Product"
                onBack={props.handleBackModifierComboSelect}
                onClose={props.handleProductModalClose}
            />
            <ModifierComboGroupsListModalPage
                modifierComboDetails={props.modifierComboDetails}
                modifierComboGroupFormData={modifierComboGroupFormData} // Passing productFormData only for selected Modifier Combo
                handleModifierComboGroupSelect={props.handleModifierComboGroupSelect}
                handleModComboAddComboToProduct={props.handleModComboAddComboToProduct}
                currentLocation={props.currentLocation}
                errorModifierCombo={props.errorModifierCombo}
            />
        </>
    } else if (props.productModalDisplay.showModalPage === "Modifier Combo Group Details") { // Regular Product - Modifier Group Details inside selected Group inside selected Modifier Combo
        let modifierComboFormData =  props.productFormData.data.Mods.find((modCombo) => { // Finding the formData that contains the modifier combo
            return modCombo.fieldName == `ModComboModCatId${props.modifierComboDetails.modifierComboDetails.modCategoryId}`
        });

        modalBody =
        <>
            <Head
                title="Add selection to Combo"
                onBack={props.handleBackModifierComboGroupSelect}
                onClose={props.handleProductModalClose}
            />
            <ModifierComboGroupDetailsModalPage
                modifierComboDetails={props.modifierComboDetails}
                modifierComboFormData={modifierComboFormData}
                handleModifierChangeModComboGroup={props.handleModifierChangeModComboGroup}
                handleModifierComboAddSelectionToGroup={props.handleModifierComboAddSelectionToGroup}
                currentLocation={props.currentLocation}
                errorModifierCombo={props.errorModifierCombo}
            />
        </>
    } else if (props.productModalDisplay.showModalPage === "Product Combo List") { // Product Combo - Selection List
        modalBody =
            <>
                <Head
                    title="Select Product"
                    onBack={props.handleBackProductComboGroupSelect}
                    onClose={props.handleProductModalClose}
                />
                <ProductComboListModalPage
                    productDetails={props.productDetails}
                    productComboChildDetails={props.productComboChildDetails}
                    handleSelectProductInComboList={props.handleSelectProductInComboList}
                />
            </>
    } else if (props.productModalDisplay.showModalPage === "Product Combo Child Details") { // Product Combo Child Product - Details
        modalBody =
            <>
                <Head
                    title="Product Details"
                    onBack={props.handleBackProductComboChild}
                    backDisabled={props.addToProductComboError.ButtonsDisabled}
                    onClose={props.handleProductModalClose}
                    closeDisabled={props.addToProductComboError.ButtonsDisabled}
                />
                <ProductComboChildModalPage
                    productComboChildDetails={props.productComboChildDetails}
                    productComboChildFormData={props.productComboChildFormData}
                    currentLocation={props.currentLocation}
                    handleProductComboChildFormChange={props.handleProductComboChildFormChange}
                    handleProductComboModFormChange={props.handleProductComboModFormChange}
                    handleAddToProductCombo={props.handleAddToProductCombo}
                    addToProductComboError={props.addToProductComboError}
                />
            </>
    }

    return(
        <>
            <Modal
                show={props.productModalDisplay.showProductModal}
                backdrop="static"
                keyboard={false}
                centered
                scrollable
                dialogClassName="wo-pm"
                contentClassName="wo-pm__content"
            >
                {modalBody}
            </Modal>
        </>
    )
}
